import { CompetitionStatus } from '@api/competitionsApi/interfaces';
import { ROUTES } from '@routes/routes';

export const getPortalCompetitionDetailsRoute = (
  slug: string,
  status: CompetitionStatus
): string =>
  status === 'completed'
    ? ROUTES.portal.competitions.results.details(slug)
    : ROUTES.portal.competitions.details(slug);
